import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';

import { force_disable_content_loader } from '@rpt-ngrx/actions/ui.action';

@Component({
    selector: 'dm-no-content',
    template: `
        <ng-container [ngSwitch]="type">
            <ng-container *ngSwitchCase="'no-sites'">
                <div class="error-container">
                    <h1>
                        You are not assigned to any sites within this company. No reports are available. Please make
                        sure you are assigned to at least 1 site before accessing reports.
                    </h1>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'no-company-data'">
                <div class="error-container">
                    <h1>Error while getting data for this company.</h1>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="error-container">
                    <h1>404: page is missing</h1>
                </div>
            </ng-container>
        </ng-container>
    `,
    styles: [
        `
            .error-container {
                padding: 5px 15px;
            }
        `,
        `
            .error-container h1 {
                max-width: 90%;
            }
        `,
    ],
})
export class NoContentComponent implements OnInit {
    public type = 'no-page';

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            if (params['type']) {
                this.type = params['type'];
            }
            this.store.dispatch(force_disable_content_loader());
            this.cdRef.detectChanges();
        });
    }
}
